<template>
	<div class="ecommerce-product-image-carousel">
		<div class="carousel">
			<SwiperCarousel
				dots
				loop
				:key="images?.[0].src"
			>
				<SwiperCarouselSlide
					v-for="(image, i) in images"
					:key="image.src"
				>
					<NuxtImg
						class="margin-vertical-3xl"
						:loading="i === 0 ? 'lazy' : 'eager'"
						:src="image.src"
						:alt="image.alt"
						:custom="true"
						v-slot="{ isLoaded, imgAttrs }"
					>
						<img
							v-if="isLoaded"
							v-bind="imgAttrs"
						/>
						<div
							v-else
							class="loading-container"
						>
							<TnSpinner />
						</div>
					</NuxtImg>
				</SwiperCarouselSlide>
			</SwiperCarousel>
		</div>
	</div>
</template>
<script setup lang="ts">
defineComponent({
	name: "ECommerceProductImageCarousel",
});
interface Image {
	src: string;
	alt?: string;
}
const props = defineProps({
	modal: {
		type: Boolean,
		default: false,
	},
	productProp: {
		type: Object,
		default: undefined,
	},
	component: {
		type: Object,
		default: undefined,
	},
});
const { eCommerceProduct } = useECommerceProduct(props.productProp);

const content = computed(() => props.component?.content);

const images = computed<Image[]>(() => {
	let filterFn: (image: any, idx?: number) => boolean;

	if (content.value?.images) return content.value?.images;
	if (eCommerceProduct.value?.images) {
		if (eCommerceProduct.value.images.some((img: any) => img.image?.indexOf("176px") > 0))
			filterFn = (image: any) => image.image?.indexOf("176px") < 0; // Remove thumbnail images
		else if (
			eCommerceProduct.value.images.length > 1 &&
			!eCommerceProduct.value.images[0]?.url?.indexOf("bluestonepim")
		) {
			filterFn = (image: any, idx: number) => idx > 0; // Remove first image (assume first is thumbnail)
		} else filterFn = () => true; // Only 0 or 1 image present, filter nothing

		const images = eCommerceProduct.value.images.filter(filterFn).map((image: any) => {
			if (image.url.includes("bluestonepim")) {
				return {
					src: image.url,
					alt: image.imageName || image.name,
				};
			}
			return {
				src: image.url,
				alt: image.imageName || image.name,
			};
		});

		if (eCommerceProduct.value.campaignImage) images.unshift({ src: eCommerceProduct.value.campaignImage });

		return images;
	} else {
		return [];
	}
});
</script>
<style lang="scss" scoped>
.ecommerce-product-image-carousel {
	padding: 0 $spacing-xl;
	height: 100%;
	border: $color-neutrals-25-tint;

	img {
		margin: 32px auto;
		display: block;
		max-width: 100%;
		height: 30vh;
	}

	.single-image {
		margin: 0 auto;
	}

	@include breakpoint(mobile) {
		max-height: 100%;
	}

	@include breakpoint(mobile) {
		padding: $spacing-2xl $spacing-l;
		margin-left: -15px;
		margin-right: -15px;
		min-height: 0;
	}
}
.loading-container {
	height: 400px;
	width: 400px;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>
